<template>
  <label class="custom-field__label" :class="{ required: field.required }" v-if="field.label">
    {{ field.label }}
    <custom-field-description-helper :description="field.description" />
  </label>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CustomFieldLabel',
  props: {
    field: {
      type: Object,
      required: true
    }
  }
});
</script>
